export default __webpack_public_path__ + "static/media/git-concluion.1c2ff9a1.png";